import React from 'react';
import BusinessIntelligenceHub from '../../components/business/BusinessIntelligenceHub';

/**
 * Dedicated Business Intelligence Page
 * AI-powered insights, recommendations, and strategic analysis
 */
const AdminBusinessIntelligence = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">בינה עסקית</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            תובנות חכמות, המלצות אסטרטגיות וניתוח עסקי מתקדם מבוסס AI
          </p>
        </div>
        <div className="flex items-center space-x-3 mt-4 sm:mt-0">
          <div className="flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400">
            <div className="w-2 h-2 bg-amber-500 rounded-full animate-pulse"></div>
            <span>מנוע AI פעיל</span>
          </div>
        </div>
      </div>

      {/* Full Business Intelligence Hub Component */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <BusinessIntelligenceHub />
      </div>
    </div>
  );
};

export default AdminBusinessIntelligence;
